const config = JSON.parse(document.getElementById('config_json').innerText);
fc2.init(config.fc2);
fc2.onAccept('youtube', function() {
    console.log('youtube accepted');
});
fc2.onDecline('youtube', function() {
    console.log('youtube declined');
    const iframe = document.querySelector('iframe[src^="https://www.youtube.com/"]')
    if (iframe) {
        iframe.remove()
    }
})